import type { SubscriptionBlockSubStatusType } from '@subscriptions/domain/types';
import { SubscriptionBlockSubStatuses } from '@subscriptions/domain/types';

/**
 * Validated subscription block payment sub-status value object.
 * The empty string represents an absent/unknown sub-status produced by soft-validation reconstruction.
 */
export type SubscriptionBlockSubStatus = Readonly<SubscriptionBlockSubStatusType | ''>;

const validSubStatuses = Object.values(SubscriptionBlockSubStatuses) as string[];

/**
 * Creates a validated SubscriptionBlockSubStatus value object.
 *
 * @param raw - Raw sub-status string
 * @returns Validated SubscriptionBlockSubStatus
 * @throws Error if sub-status is not a valid value
 */
export const createSubscriptionBlockSubStatus = (raw: string): SubscriptionBlockSubStatus => {
  if (!validSubStatuses.includes(raw)) {
    throw new Error(`Invalid subscription block sub-status: ${raw}. Must be one of: ${validSubStatuses.join(', ')}`);
  }
  return raw as SubscriptionBlockSubStatus;
};
